const { format: formatDate, } = require('date-fns');
const { utcToZonedTime } = require('date-fns-tz');

const formatAsTokyoTime = (date, ...args) => formatDate(utcToZonedTime(date, 'Asia/Tokyo'), ...args);

module.exports = {
  formatAsTokyoTime,
};
